import o from "./ghl-ui.es1453.js";
import t from "./ghl-ui.es1454.js";
import a from "./ghl-ui.es1455.js";
import r from "./ghl-ui.es1456.js";
import m from "./ghl-ui.es1457.js";
var e = {
  code: "hu",
  formatDistance: o,
  formatLong: t,
  formatRelative: a,
  localize: r,
  match: m,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const s = e;
export {
  s as default
};
